// libraries
import React from "react";
import { Helmet } from "react-helmet";

// components
import logoKJ from "../../public/logoKJCropped.png";

function About () {
  return (
    <div className="about">
      <Helmet>
        <title>Contact Us</title>
      </Helmet>
      <img src={logoKJ} width="95%"></img>

      <h4 style={{ textAlign: 'center', color: '#020266' }} className="info">
      Developed and Maintained By
      </h4>
      {/* <h2>Portal Developed By</h2> */}
      <p className="paragraph">
   Parth Maniar - Student, B.E. (Information Technology)
   
           <br />
          Dr. Radhika Kotecha, Head - Department of Information Technology
      </p>

        <div >For any queries, write to, </div>
      <a style={{textDecoration: 'none'}} href="mailto:radhika.kotecha@somaiya.edu"><i className="fas fa-envelope me-2 "></i>&nbsp; radhika.kotecha@somaiya.edu</a>

      <div className="socials">
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://kjsieit.somaiya.edu"
          className="social-icon icon-only li"
        >
          <i className="fa fa-globe" />
        </a>

        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.youtube.com/c/KJSIEITofficial"
          className="social-icon icon-only yt"
        >
          <i className="fab fa-youtube" />
        </a>
        <a
          href="https://www.facebook.com/kjsieitofficial"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only li"
        >
          <i className="fab fa-facebook-square" />
        </a>
        <a
          href="https://www.instagram.com/kjsieit_22"
          target="_blank"
          rel="noopener noreferrer"
          className="social-icon icon-only gi"
        >
          <i className="fab fa-instagram" />
        </a>
      </div>
    </div>
  );
}

export default About;
